
 // LOADEvo — route paint shared by Sessions, Trucks and Drivers.
 // GeoJSON features must expose routePart = "completed" | "remaining".

export function addSharedOperationalRouteLayers(
  map,
  { sourceId, neonId, casingId, lineId, highlightId }
) {
  const remainingFilter = [
    "==",
    ["get", "routePart"],
    "remaining",
  ];

  const layout = {
    "line-cap": "round",
    "line-join": "round",
  };

  map.addLayer({
    id: neonId,
    type: "line",
    source: sourceId,
    filter: remainingFilter,
    layout,
    paint: {
      "line-color": "#1769FF",
      "line-width": 22,
      "line-blur": 6,
      "line-opacity": 0.8,
    },
  });

  map.addLayer({
    id: casingId,
    type: "line",
    source: sourceId,
    layout,
    paint: {
      "line-color": [
        "match",
        ["get", "routePart"],
        "completed", "#0B2B66",
        "remaining", "#278CFF",
        "#278CFF",
      ],
      "line-width": [
        "case",
        ["boolean", ["get", "selected"], false],
        11,
        7,
      ],
      "line-opacity": 1,
    },
  });

  map.addLayer({
    id: lineId,
    type: "line",
    source: sourceId,
    layout,
    paint: {
      "line-color": [
        "match",
        ["get", "routePart"],
        "completed", "#16478F",
        "remaining", "#278CFF",
        "#278CFF",
      ],
      "line-width": [
        "case",
        ["boolean", ["get", "selected"], false],
        7,
        4,
      ],
      "line-opacity": [
        "case",
        ["boolean", ["get", "selected"], false],
        1,
        0.55,
      ],
    },
  });

  map.addLayer({
    id: highlightId,
    type: "line",
    source: sourceId,
    filter: remainingFilter,
    layout,
    paint: {
      "line-color": "#D9F6FF",
      "line-width": 2,
      "line-opacity": 0.95,
    },
  });
}
